export function localizeUrl(url) {
  if (!url) return url;
  if (/^(https?:)?\/\//.test(url) || url.startsWith('#')) return url;

  const root = window.Shopify?.routes?.root || '/';
  if (root === '/' || url.startsWith(root)) return url;

  const cleanRoot = root.endsWith('/') ? root : `${root}/`;
  const cleanUrl = url.startsWith('/') ? url.slice(1) : url;

  return `${cleanRoot}${cleanUrl}`;
}
